module.exports = __webpack_public_path__ + "img/iconProvince5.0e51fa9f.svg";